import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { updateStatusProduct } from "../api";

type CustomError = {
  response?: {
    data?: {
      message?: string;
      status?: string;
    };
  };
};
export const useUpdateProduct = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: updateStatusProduct,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["PRODUCT"] });
      queryClient.refetchQueries({ queryKey: ["PRODUCT-ALL"] });
      router("/product");
      toast.success("Success Update Product");
    },

    onError(error: unknown) {
      console.log(error);
      const err = error as CustomError;
      const message = err?.response?.data?.message
        ? `Status: ${err.response.data.status} - ${err.response.data.message}`
        : "Terjadi kesalahan pada database.";

      toast.error(message);
    },
  });

  return { Update: mutate, isPending };
};
